import { render, staticRenderFns } from "./uploadIDCard.vue?vue&type=template&id=4e209caa&scoped=true"
import script from "./uploadIDCard.vue?vue&type=script&lang=js"
export * from "./uploadIDCard.vue?vue&type=script&lang=js"
import style0 from "./uploadIDCard.vue?vue&type=style&index=0&id=4e209caa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e209caa",
  null
  
)

export default component.exports